import React from 'react';

import PropTypes from 'prop-types';
import { Skeleton } from '@/components/ui/skeleton';

import {
  Avatar as ShadcnAvatar,
  AvatarFallback,
  AvatarImage,
} from '@/components/ui/avatar';

const DEFAULT_SIZE = 'md';

const COLOR_CLASSES = {
  red: 'bg-red-500',
  orange: 'bg-orange-500',
  amber: 'bg-amber-500',
  yellow: 'bg-yellow-500',
  lime: 'bg-lime-500',
  green: 'bg-green-500',
  emerald: 'bg-emerald-500',
  teal: 'bg-teal-500',
  cyan: 'bg-cyan-500',
  sky: 'bg-sky-500',
  blue: 'bg-blue-500',
  indigo: 'bg-indigo-500',
  violet: 'bg-violet-500',
  purple: 'bg-purple-500',
  fuchsia: 'bg-fuchsia-500',
  pink: 'bg-pink-500',
  rose: 'bg-rose-500',
};

const SIZE_CLASSES = {
  sm: 'h-5 w-5',
  md: 'h-9 w-9',
  lg: 'h-11 w-11',
};

const TEXT_CLASSES = {
  sm: 'text-[10px]',
  md: 'text-sm',
  lg: 'text-base',
};

const Avatar = ({ backgroundColor, initials, size = DEFAULT_SIZE }) => (
  <ShadcnAvatar className={`border border-white ${SIZE_CLASSES[size]}`}>
    {/* TODO: Replace src. */}
    <AvatarImage alt="avatar" src="/placeholder.svg" />

    <AvatarFallback
      className={`text-white ${COLOR_CLASSES[backgroundColor]} ${TEXT_CLASSES[size]}`}
    >
      {initials}
    </AvatarFallback>
  </ShadcnAvatar>
);

Avatar.Skeleton = function ({ size = DEFAULT_SIZE }) {
  return <Skeleton className={`rounded-full ${SIZE_CLASSES[size]}`} />;
};

Avatar.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  initials: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

Avatar.Skeleton.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default Avatar;
